import { Component, Inject } from '@angular/core';
import { Event } from '@models/events/event.model';
import { User } from '@models/users/user.model';
import { EventAttendee } from '@models/event-attendance/event-attendee.model';
import { EventAttendeeTicketOrder } from '@models/events/event-attendee-ticket-order.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PremiumAfterAttendComponent } from '@modules/events/components/premium-after-attend/premium-after-attend.component';
import { RSVPOptionType } from '@models/event-attendance/rsvp-option-type.enum';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule, PremiumAfterAttendComponent],
  templateUrl: './premium-after-attend.dialog.html',
  styleUrl: './premium-after-attend.dialog.scss',
})
export class PremiumAfterAttendDialog {
  event?: Event;
  rsvpType: RSVPOptionType = RSVPOptionType.YES;
  onWaitlist: boolean = false;
  onPendingList: boolean = false;
  loggedUser?: User;
  eventAttendee?: EventAttendee;
  isDesktop: boolean = true;
  withTickets?: boolean = false;
  ticketOrder?: EventAttendeeTicketOrder;
  myOrders?: EventAttendeeTicketOrder[];

  constructor(
    public dialogRef: MatDialogRef<PremiumAfterAttendDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data?.event) {
      this.rsvpType = data.rsvpType;
      this.event = data.event;
      this.eventAttendee = data.eventAttendee;
      this.onWaitlist = data.onWaitlist;
      this.onPendingList = data.onPendingList;
      this.withTickets = data.withTickets;
      this.ticketOrder = data.ticketOrder;
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
